<template>
    <div class="login-confirm">
        <div class="w-full h-full flex flex-center justify-center relative">
            <div class="login-box relative" style="z-index: 1">
                <img class="img-bg w-full h-full absolute left-0 top-0" src="@/assets/images/login/login-bg-icon-3.png"
                    style="z-index: -1" />
                <div class="w-full h-full flex justify-center items-center py-[113px]" style="z-index: 2">
                    <div class="login-form flex flex-col flex-center text-[#333]">
                        <p class="text-3xl font-semibold text-center mb-2.5">Welcome ctv.trolyhoadon.vn</p>
                        <p class="text-xl font-semibold text-center mb-9">Please login to your account</p>

                        <Form class="w-full" @submit="onSubmit" :validation-schema="schema" @input="handleFormInput">
                            <div class="w-full relative">
                                <Field name="email" v-model="email" class="w-full p-[14px] !pl-[43px] input"
                                    placeholder="Email" />
                                <img src="@/assets/images/login/lg-admin-gray.png" class=" input-image" />
                            </div>
                            <div class="mb-8">
                                <ErrorMessage name="email" />
                            </div>
                            <div class="w-full relative">
                                <Field name="password" v-model="password"
                                    class="w-full h-[52px] p-[14px] !px-[43px] input"
                                    :type="isPasswordShown ? 'text' : 'password'" placeholder="Password" />
                                <img src="@/assets/images/login/lg-password-gray.png"
                                    class="absolute left-[14px] input-image" />
                                <img src="@/assets/images/login/show-password.svg" @click="togglePasswordView"
                                    v-if="!isPasswordShown"
                                    class="absolute !right-[14px] !left-auto !pointer-events-auto input-image" />
                                <img src="@/assets/images/login/hide-password.svg" @click="togglePasswordView" v-else
                                    class="absolute !right-[14px] left-auto !pointer-events-auto input-image" />
                            </div>
                            <ErrorMessage name="password" />
                            <div class="py-4">
                                <span class="text-center block text-danger" role="alert" v-if="errorMessage">{{
                                    errorMessage }}</span>
                            </div>
                            <button class="w-full btn btn-success h-[64px] rounded-xl text-white" type="submit">Log
                                In</button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from 'yup';
import { api, setToken } from '../api/client'

const router = useRouter();

const email = ref("");
const password = ref("");
const isLoading = ref(false)
const schema = yup.object({
    email: yup.string().required("Email is required!"),
    password: yup.string().required("Password is required!")
});

const errorMessage = ref("");

const isPasswordShown = ref(false);

const togglePasswordView = () => {
    isPasswordShown.value = !isPasswordShown.value;
}

const handleFormInput = () => {
    errorMessage.value = "";
}

const onSubmit = async () => {
    errorMessage.value = "";
    schema.validate({ email: email.value, password: password.value }).then(async () => {
        isLoading.value = true
        let payload = {
            email: email.value,
            password: password.value,
        }
        try {
            const { data } = await api.post('/api/auth/login', payload)
            if (data?.token) {
                localStorage.setItem('ctv_token', data.token)
                localStorage.setItem('ctv_account', JSON.stringify(data.account))
                setToken(data.token)
                window.dispatchEvent(new Event('auth-changed'))
                router.push('/dashboard')
            }
        } catch (err) {
            console.log('Error: ', err);
            errorMessage.value = "Username or password is incorrect!";
        } finally {
            isLoading.value = false
        }
    }).catch((err) => {
        console.log('Error: ', err);
    });
}

</script>

<style scoped>
.login-confirm {
    width: 100vw;
    height: 100vh;
    background-color: #abc4ff;

}

.login-confirm .login-box {
    width: 1180px;
    max-width: calc(100% - 40px);

}

.login-confirm .login-box .input-image {
    width: 20px !important;
    height: auto;
    z-index: 1;
    pointer-events: none;
    position: absolute;
    top: 14px;
    left: 10px;
}

.input {
    height: 48px;
    background-color: #fff;
}
</style>
